export var IntrinsicTypes;
(function (IntrinsicTypes) {
    IntrinsicTypes[IntrinsicTypes["String"] = 'string'] = "String";
    IntrinsicTypes[IntrinsicTypes["Boolean"] = 'boolean'] = "Boolean";
    IntrinsicTypes[IntrinsicTypes["Number"] = 'number'] = "Number";
})(IntrinsicTypes || (IntrinsicTypes = {}));
//# sourceMappingURL=typeInfo.js.map